



export const Certifications = [
  {
    src: 'assets/certifications/enisa_startup.png',
    alt: 'Certificado de empresa emergente de Enisa',
    url: 'https://www.enisa.es/',
  },
  {
    src: 'assets/certifications/audidat.png',
    alt: 'Certificado AUDIDAT CUMPLE referente al reglamento general de protección de datos (RGPD)',
    url: 'https://www.audidat.com/blog/proteccion-de-datos/nace-el-programa-de-cumplimento-normativo-audidat-cumple/',
  },
  {
    src: 'assets/certifications/ISO_27001.png',
    alt: 'Estandar Internacional de Seguridad de la Información',
    url: 'assets/pdf/ISO_27001_EN.pdf',
  },
  {
    src: 'assets/certifications/ISO_13485.png',
    alt: 'Sistemas de Gestión de Calidad para Dispositivos Médicos',
    url: 'assets/pdf/ISO_13485_EN.pdf',
  },
  {
    src: 'assets/certifications/ENS.png',
    alt: 'Esquema Nacional de Seguridad (ENS)',
    url: 'assets/pdf/ENS.pdf',
  },
]


export const Funding = [
  {
    src: 'assets/funding/SPEGC_Logo.svg',
    alt: 'Sociedad de Promoción Económica de Gran Canaria (SPEGC)',
    url: 'https://www.spegc.org/',
  },  
  {
    src: 'assets/funding/enisa_financiacion.png',
    alt: 'Certificado de haber recibido financiación de Enisa',
    url: 'https://www.enisa.es/',
  }, 
  {
    src: 'assets/funding/gobcan.png',
    alt: 'Gobierno de Canarias, Consejería de Economía, Conocimiento y Empleo, Agencia Canaria de Investigación, Innovación y Sociedad de la Información',
    url: 'https://www.enisa.es/',
  },  
  {
    src: 'assets/funding/union_europea.png',
    alt: 'Cofinanciado por la Union Europea',
    url: '',
  },
  {
    src: 'assets/funding/gobierno_esp.png',
    alt: 'Gobierno de España',
    url: '',
  },
  {
    src: 'assets/funding/fondos_europeos.png',
    alt: 'Fondos Europeos',
    url: '',
  },
  {
    src: 'assets/funding/proexca.png',
    alt: 'Sociedad Canaria de Fomento Económica, SA',
    url: 'https://proexca.es/',
  },
  {
    src: 'assets/funding/ministerio_ciencia_e_innovacion.png',
    alt: 'Ministerio de Ciencia, Innovación y Universidades',
    url: 'https://www.ciencia.gob.es/',
  },
  {
    src: 'assets/funding/agencia_estatal_investigacion.png',
    alt: 'Agencia Estatal de Investigación',
    url: 'https://www.aei.gob.es/',
  },

  
  


]


export const Partners = [
  {
    src: 'assets/partners/AdventiaPharma_Logo.svg',
    alt: 'Adventia Pharma',
    url: 'https://adventiapharma.com/',
  },
  {
    src: 'assets/partners/VHIR_Logo.svg',
    alt: "Vall d'Hebron Institut de Recerca",
    url: 'https://vhir.vallhebron.com/en',
  },
  {
    src: 'assets/partners/ULPGC_Startup_Logo_Cut.svg',
    alt: 'Certificado de startup de la Universidad de Las Palmas de Gran Canaria (Startup ULPGC)',
    url: 'https://ulpgc.es',
  },
  {
    src: 'assets/partners/VH_Logo.svg',
    alt: "Vall d'Hebron Barcelona Hospital Campus",
    url: 'https://www.vallhebron.com/en',
  }, 
  {
    src: 'assets/partners/KUNSEN_Logo.svg',
    alt: 'KUNSEN Digital Health Accelerator',
    url: 'https://www.kunsen.health/',
  },   
]

